import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";

interface Props {
  projectId: string;
  active: "board" | "backlog" | "epics" | "sprints";
}

// Deliberately not importing `routes` from navigation/routes/routes.tsx here:
// that module imports every page (via src/pages/index.ts) to build its
// `Pages` array, and every project-scoped page imports this component —
// pulling `routes` in would create pages -> ProjectNav -> routes -> pages
// circular import, which left `Pages`' JSX referencing components that were
// still `undefined` at module-eval time. Path segments are simple/stable
// enough to inline directly.
const TABS: { key: Props["active"]; label: string; segment: string }[] = [
  { key: "board", label: "Board", segment: "board" },
  { key: "backlog", label: "Backlog", segment: "backlog" },
  { key: "epics", label: "Epics", segment: "epics" },
  { key: "sprints", label: "Sprints", segment: "sprints" },
];

/**
 * Small tab strip linking the four project-scoped Scrum pages (Board,
 * Backlog, Epics, Sprints) so a user landing on any one of them can reach the
 * other three — none of them link to each other otherwise.
 */
export const ProjectNav = ({ projectId, active }: Props) => {
  const navigate = useNavigate();

  return (
    <Tabs
      activeKey={active}
      onChange={(key) => {
        const tab = TABS.find((t) => t.key === key);
        if (tab) navigate(`/projects/${projectId}/${tab.segment}`);
      }}
      items={TABS.map(({ key, label }) => ({ key, label }))}
    />
  );
};
